import { BAOCustomElement } from '@bao/custom-element'
import { MediaBreakpoints } from '@bao/media'
import { debounce, getOffsetTop } from '@bao/utils'

class StickyScroll extends BAOCustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.scrollDirection = ''
    this.scrollDirectionPrevious = ''

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.setupResizeListener = this.setupResizeListener.bind(this)
    this.setupScrollListener = this.setupScrollListener.bind(this)

    this.scrollListenerSetup = false
    this.setupResizeListener()
    this.setupScrollListener()

    if (!MediaBreakpoints.isMd) return

    this.updateEl()
  }

  setupResizeListener () {
    this.debouncedResize = debounce(() => {
      this.setupScrollListener()
      this.removeSticky()
    }, 240)

    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  setupScrollListener () {
    if (!MediaBreakpoints.isMd || this.scrollListenerSetup) return

    this.onScroll = this.onScroll.bind(this)
    this.listeners.add(window, 'scroll', this.onScroll)
    this.scrollListenerSetup = true
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    this.scrollDirectionPrevious = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setSticky()
  }

  setSticky () {
    if (!this.els?.container?.exists) return

    const containerHeight = this.els.container.element.offsetHeight
    const contentHeight = this.els.content.element.offsetHeight

    if (containerHeight > contentHeight) {
      this.classList.toggle('prd-Detail_Columns-defaultSticky', false)
      this.classList.toggle('prd-Detail_Columns-isSticky', true)

      const offsetAmount = window.innerHeight - contentHeight

      if (this.scrollDirectionPrevious !== this.scrollDirection) {
        const containerOffsetTop = getOffsetTop(this.els.container.element)
        const contentOffsetTop = getOffsetTop(this.els.content.element)

        this.els.spacer.element.style.setProperty(
          'margin-top',
          `${contentOffsetTop - containerOffsetTop}px`,
        )
      }

      if (this.scrollDirection === 'down') {
        if (window.innerHeight < contentHeight) {
          this.els.content.element.style.setProperty(
            'top',
            `calc(${offsetAmount}px - var(--Site_Margin))`,
          )
        } else {
          this.els.content.element.style.setProperty(
            'top',
            'var(--Header_Sub_Height)',
          )
        }

        this.els.content.element.style.removeProperty('bottom')
      } else {
        if (document.body.classList.contains('lyt-Theme-scrolledUp')) {
          this.els.content.element.style.setProperty(
            'bottom',
            `calc(${offsetAmount}px - var(--Header_Banner))`,
          )
        } else {
          this.els.content.element.style.setProperty(
            'bottom',
            `${offsetAmount}px`,
          )
        }

        this.els.content.element.style.removeProperty('margin-top')
      }

      return
    }

    this.removeSticky()
  }

  removeSticky () {
    this.classList.toggle('prd-Detail_Columns-defaultSticky', true)
    this.classList.toggle('prd-Detail_Columns-isSticky', false)

    this.els.content.element.style.removeProperty('top')
    this.els.content.element.style.removeProperty('bottom')
    this.els.spacer.element.style.removeProperty('margin-top')
  }
}

if (!customElements.get('sticky-scroll')) {
  customElements.define('sticky-scroll', StickyScroll)
}
